/**
 * EVM chains on which the Sablier Protocol is deployed, exported individually and as a `chains` object.
 *
 * This module exports the EVM chains supported by Sablier, including both mainnets and testnets.
 * Each chain is defined with its explorer URL, chain ID, native token, and other properties.
 *
 * For further documentation, visit:
 * @see https://docs.sablier.com/concepts/chains
 * @see https://chainlist.org
 */
export * as chains from "./chains.js";
export * from "./chains.js";
